
import WrapComponents from "./WrapComponents.vue";
export default {
  components: {
    WrapComponents,
  },
  props: {
    iconURL: {
      type: String,
    },
    title: {
      type: String,
    },
    linkTo: {
      type: String,
    },
    linkName: {
      type: String,
    },
    titleStyle: {
      type: String,
      default: "",
    },
  },
  computed: {
    isExternal() {
      return this.linkTo && /^(https?:)?\/\//.test(this.linkTo);
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
    };
  },
};
